import Immutable from 'immutable';
import {
  SET_COURSE_PROGRESS,
  SET_COURSE_PROGRESS_FOR_USER,
  PROGRESS_PAGE_SUCCESS,
  PROGRESS_PAGE_FAILED,
} from './actions';
import { LOGOUT_SUCCESS } from '../../Auth/actions';
import { FETCH_STUDENT_CERTIFICATIONS_SUCCESS } from '../../Certification/actions';
/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function CourseProgress(state = Immutable.Map(), action) {
  const setProgress = (oldState, progress, coursePath, user) => {
    let updatedState = oldState;
    updatedState = updatedState.set(coursePath, progress);
    if (user) {
      updatedState = updatedState.updateIn(
        ['byUser', user, coursePath],
        Immutable.Map(),
        (p) => p.merge(progress)
      );
    }
    return updatedState;
  };

  switch (action.type) {
    case SET_COURSE_PROGRESS: {
      const { coursePath, progress } = action;
      return setProgress(
        state,
        Immutable.fromJS(progress),
        coursePath,
        action.user || null
      );
    }
    case FETCH_STUDENT_CERTIFICATIONS_SUCCESS: {
      const { progress: progressByUser, coursePath } = action;
      let newState = state;
      Immutable.fromJS(progressByUser).forEach((progress, userId) => {
        newState = newState.updateIn(
          ['byUser', userId, coursePath],
          Immutable.Map(),
          (p) => p.merge(progress)
        );
      });
      return newState;
    }
    case SET_COURSE_PROGRESS_FOR_USER: {
      const { user, coursePath, progress } = action;
      return state.updateIn(
        ['byUser', user, coursePath],
        Immutable.Map(),
        (p) => p.merge(progress)
      );
    }
    case PROGRESS_PAGE_SUCCESS: {
      const { coursePath, cohortPath, progress, summaries } = action;
      let newState = state;
      newState = newState.setIn(
        ['byCoursePath', coursePath],
        Immutable.fromJS({
          inProgress: false,
          error: false,
          coursePath,
          cohortPath,
          progress,
          summaries,
        })
      );
      return newState;
    }
    case PROGRESS_PAGE_FAILED: {
      const { coursePath, cohortPath } = action;
      let newState = state;
      newState = newState.setIn(
        ['byCoursePath', coursePath],
        Immutable.fromJS({
          inProgress: false,
          error: true,
          coursePath,
          cohortPath,
          progress: null,
          summaries: null,
        })
      );
      return newState;
    }
    case LOGOUT_SUCCESS: {
      return Immutable.Map();
    }

    default:
      return state;
  }
}
